export const THEME_KEY = "theme";
export const THEMES = ["theme-light", "theme-dark"];
